<template>
  <ServiceTicketForm
      :value="ticket"
      :isEdit="true"
      :busy="isBusy"
      saveLabel="Update Service Ticket Details"
      @save="saveTicketDetails"
  />
</template>

<script>
import ServiceTicketForm from "@/components/ServiceTickets/ServiceTicketForm.vue";

export default {
  name: "EditServiceTicketDetail",
  components: {
    ServiceTicketForm,
  },
  props: {
    ticket: {
      required: true,
      type: Object,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    saveTicketDetails(payload) {
      this.$emit("complete", payload);
    },
  },
};
</script>
